// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"67af1196","250":"0db5dad7","273":"9ad6c522","406":"efac5cec","832":"d48a7e9e","961":"0db5dad7"}[chunkId] + ".chunk.css";
};